module.exports = __webpack_public_path__ + "img/compony.6475aa31.jpg";